import * as React from "react"
import { Link } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"
import WitchCounter from '../components/witchcounter'
import Layout from "../components/layout"
import Seo from "../components/seo"
import WitchForm from "../components/witchform"

const IndexPage = () => (
  <Layout>
    <Seo title="Mint" />

    <div className="homepage">
      <div class="mint__grid">
      <StaticImage
        src="../images/banner1.jpg"
        className="banner1-img"
        // width={700}
        height={550}
        left={2}
        quality={95}
        formats={["auto", "webp", "avif"]}
        alt="Wicked Witch Banner"
      />
        <div class="mint__grid__item">
          <h1 class="mint__title">Mint Witches</h1>
          <h2 class="mint__title">0.0666 ETH</h2>
          <p class="mint__max">You can mint a max of 25 per transaction</p>
          
          {/* <div class="mintpercy__img__container" >
            <StaticImage
              src="../images/pmcommon1.png"
              quality={100}
              alt="Percy common skin one"
              class="mintpercy__img"
            />
          </div> */}
          <div class="mint__button__container">
          <WitchForm />
          </div>
        </div>
      </div>
    </div>  
  </Layout>
)

export default IndexPage
